import React, { useMemo } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Loader from '../../utils/Loader';
import moment from 'moment';


const PortfolioModal = ({ isOpen, toggle, user, loading }) => {

  const products = useMemo(() => {
    return user?.products || [];
  }, [user])

  const onHideModal = () => {
    toggle();
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'approved':
        return <span className='badge badge-success'>APPROVED</span>;
      case 'pending':
        return <span className='badge badge-warning'>PENDING</span>;
      case 'rejected':
        return <span className='badge badge-danger'>REJECTED</span>;
      default:
        return <span className='badge badge-secondary'>{status.toUpperCase()}</span>;
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal}>
        <div className='d-flex align-items-center'>
          <div className='fw-600'>Portfolio</div>
          <div className='ml-3'>
            <Loader isLoading={loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <table className="table table-hover text-center">
          <thead>
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Tokens</th>
              <th scope="col">Partner Reward</th>
              <th scope="col">Status</th>
              <th scope="col">Created</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, i) => {
              const { _id, title, email, gdTokens, isPartner, createdAt, tokens, partnerReward = 0 } = product;
              const statusBadge = getStatusBadge(product.status);
              return (
                <tr key={_id}>
                  <th>{title}</th>
                  <td>{tokens}</td>
                  <td>{partnerReward}</td>
                  <td>{statusBadge}</td>
                  <td>
                    <div>{moment(user?.createdAt).format("DD/MM/YYYY")}</div>
                    <small className='text-muted'>{moment(user?.createdAt).format("h:mm:ss a")}</small>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PortfolioModal
